import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { theme } from "../../styles/styles";

export const Extra = styled("footer")`
  background: ${theme.surface};
  border-top: 1px solid ${theme.border};
  width: 100%;
  padding: 2rem 0;
`;

export const FooterRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.25rem;
`;

export const FooterLinks = styled("div")`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
`;

const footerLink = css`
  font-size: 14px;
  color: ${theme.textMuted};

  &:hover {
    color: ${theme.accent};
  }
`;

export const FooterLink = styled(Link)`
  ${footerLink}
`;

export const FooterExternalLink = styled("a")`
  ${footerLink}
`;

export const SocialRow = styled("div")`
  display: flex;
  align-items: center;
  gap: 1rem;

  a {
    display: flex;
    padding: 8px;
    border-radius: 10px;
    background: #e9ecf2;
    transition: transform 0.15s ease-in-out, background 0.15s ease-in-out;

    &:hover {
      transform: translateY(-2px);
      background: #fff;
    }
  }
`;

export const Copyright = styled("div")`
  margin-top: 1.5rem;
  font-size: 13px;
  color: ${theme.textMuted};
`;
